import { Controller } from '@hotwired/stimulus';

export default class CsvUploadController extends Controller {
  file = '';

  allowedFileTypes = [
    'text/csv',
  ];

  errorMessages = {
    fileType: 'Please check your file type and try again.',
  };

  // css
  hiddenClass = 'hidden';
  modalErrorClass = 'modal-show-error';

  static targets = [
    'errorMessage',
    'file',
    'step',
  ];

  isValidFileType(file) {
    return this.allowedFileTypes.includes(file.type);
  }

  showErrorMessage(msg) {
    this.errorMessageTarget.innerText = msg;
    this.errorMessageTarget.classList.add(this.modalErrorClass);
  }

  hideErrorMessage(target) {
    this.errorMessageTarget.classList.remove(this.modalErrorClass);
  }

  handleFileInputOpen(e) {
    // allow user to select the same file twice
    this.fileTarget.value = null;

    // trigger a click on the file input if user presses Enter on the upload button
    if (e instanceof KeyboardEvent && e.key === 'Enter') {
      this.fileTarget.click();
    }

    this.hideErrorMessage();
  }

  canUploadFile() {
    const files = this.fileTarget.files || [];

    if (files.length > 0) {
      this.file = files[0];
      if (this.isValidFileType(this.file)) {
        return true;
      }

      this.showErrorMessage(this.errorMessages.fileType);
      return false;
    }
    return false;
  }
}
